import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[700]}`,
    background: theme.palette.grey[900],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
    position: 'sticky',
    top: 0,
    zIndex: 3,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },

  tagFilters: {
    maxHeight: theme.spacing(10),
    overflowX: 'auto',
  },
  selectedTagsPlaceholder: {
    color: theme.palette.grey[600],
  },
  additionalFilters: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
